import { Outlet } from 'react-router-dom'

export const WithoutNav = () => {
  return <Outlet />
}
